import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { cDataService } from "src/app/services/data.service";
import { cSessionService } from "src/app/services/session.service";
import { SidebarService } from "./sidebar.service";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";

interface RouteInfo {
  routerLink: string;
  icon: string;
  label: string;
}

interface SideNavToggle {
  screenWidth: number;
  collapsed: boolean;
}
@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit, OnChanges {
  @Output() onToggleSidenav: EventEmitter<SideNavToggle> = new EventEmitter();
  collapsed: boolean = false;
  public navData: RouteInfo[] = [];
  SidebarList: any = [];
  lConfigurations: any = [];
  screenWidth = 0;
  @Input() isSideNavCollapsed;
  userDetails: any;
  environmentTheme = environment.Theme;

  StaticMenus : any = [
    {
        "routerLink": "/doc-manager",
        "label": "Trillo Doc AI"
    },
    {
        "routerLink": "/filemanager",
        "label": "Trillo File Manager"
    },
    {
        "routerLink": "/datamanager",
        "label": "Data Browser"
    },
    {
        "routerLink": "",
        "label": "Separator"
    },
    {
        "routerLink": "/datasource",
        "label": "Data Source"
    },
    {
        "routerLink": "/queries",
        "label": "Queries"
    },
    {
        "routerLink": "/metadata",
        "label": "Metadata Files"
    },
    {
        "routerLink": "",
        "label": "Separator"
    },
    {
        "routerLink": "/function",
        "label": "Functions"
    },
    {
        "routerLink": "/schedules",
        "label": "Schedules"
    },
    {
        "routerLink": "",
        "label": "Separator"
    },
    {
        "routerLink": "/apiplayground",
        "label": "APIs"
    },
    {
        "routerLink": "",
        "label": "Separator"
    },
    {
        "routerLink": "/apps/task-history",
        "label": "Tasks History"
    },
    {
        "routerLink": "/logs",
        "label": "Logs"
    },
    {
        "routerLink": "",
        "label": "Separator"
    },
    {
        "routerLink": "/manage-backups",
        "label": "Manage Backups"
    },
    {
        "routerLink": "/applications",
        "label": "Applications"
    },
    {
        "routerLink": "/settings",
        "label": "Settings"
    },
    {
        "routerLink": "/groups",
        "label": "Groups"
    },
    {
        "routerLink": "/usermanager",
        "label": "Admin"
    }
]

  constructor(
    private menuServise: SidebarService,
    private oDataService: cDataService,
    private cSessionsService: cSessionService,
    private route:Router
  ) {}
  ngOnInit(): void {
    // this.drawSidebar();
    this.LoginComponent_GetConfigFile()
    this.oDataService.UpdateSidebarItems.subscribe(result =>{
      if(result)
        {
          // this.drawSidebar();
          this.LoginComponent_GetConfigFile()
        }
    })
    // if (
    //   this.userDetails.role !== "admin" ||
    //   this.userDetails.role !== "editor"
    // ) {
    //   this.collapsed = true;
    //   console.log("inside if ::: COLLAPSED NGONINIT ===>", this.collapsed);
    // }
  }
  drawSidebar(lConfig)
  {
    console.log(lConfig,"Hey this is config");
    
    this.lConfigurations = lConfig?.menus;
    this.VerticalSidebarComponent_DisplayMenuItemBasedOnUserRole();

    this.userDetails = this.cSessionsService.SessionService_GetUserDetails();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.userDetails?.role == "admin" || this.userDetails?.role == "editor"  || this.userDetails?.role == 'userSFTP')
      this.collapsed = this.isSideNavCollapsed;
  }
  VerticalSidebarComponent_DisplayMenuItemBasedOnUserRole() {
    var lMenuItems = [];
    this.navData = [];
    this.menuServise.items.subscribe(async (menuItems) => {
      lMenuItems = menuItems;      
    });
    for (
      let nConfigurationItemIndex = 0;
      nConfigurationItemIndex < this.lConfigurations?.length;
      nConfigurationItemIndex++
    ) {
      let element = this.lConfigurations[nConfigurationItemIndex];
      for (
        let nMenuItemToPushIndex = 0;
        nMenuItemToPushIndex < lMenuItems.length;
        nMenuItemToPushIndex++
      ) {
        let item = lMenuItems[nMenuItemToPushIndex];
        if (element.routerLink === item.routerLink) {
          if (
            item.routerLink === "/doc-manager" &&
            this.environmentTheme == "kidm"
          ) {
            item.label = "Doc AI";
          }
          this.navData.push(item);
          break;
        }
      }
    }
  }
  SidebarComponent_CustomizingtheSideBar(oIncomingObject) {
    let dataBaseObject: any = { database: false, bucket: false };
    dataBaseObject.database = oIncomingObject.database
      ? oIncomingObject.database
      : false;
    dataBaseObject.bucket = oIncomingObject.bucket
      ? oIncomingObject.bucket
      : false;
    if (dataBaseObject?.bucket == true && dataBaseObject?.database == false) {
      this.SidebarList = [];
      this.navData.forEach((element) => {
        if (element.label == "File Manager" || element.label == "Dashboard")
          this.SidebarList.push(element);
      });
    } else if (
      dataBaseObject?.database == true &&
      dataBaseObject?.bucket == false
    ) {
      this.SidebarList = [];
      this.navData.forEach((element) => {
        if (element.label != "File Manager") this.SidebarList.push(element);
      });
    } else if (
      dataBaseObject?.bucket == true &&
      dataBaseObject?.database == true
    ) {
      this.SidebarList = [];
      this.navData.forEach((element) => {
        this.SidebarList.push(element);
      });
    }
    if (dataBaseObject?.bucket == true && dataBaseObject?.database == false) {
      this.SidebarList = [];
      this.navData.forEach((element) => {
        if (element.label == "File Manager" || element.label == "Dashboard")
          this.SidebarList.push(element);
      });
    }
  }
  SidebarComponent_CloseSidenav() {
    this.collapsed = false;
    this.onToggleSidenav.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }
  SidebarComponent_CloseSidebar(incomingRouter) {    
    if (this.userDetails.role == "admin" || this.userDetails.role == "editor"  || this.userDetails?.role == 'userSFTP')
      this.SidebarComponent_CloseSidenav();
    if (incomingRouter != "/doc-manager") {
      this.oDataService.globalSearch.next({
        folderId: "",
        searchBoolan: false,
      });
      this.oDataService.resetSearch.next(true);
    }
     if(incomingRouter == "/doc-manager") this.route.navigate(['/dashboard'])
  }
  isActiveRoute(item: RouteInfo): boolean {
    const currentRoute = this.route.url.split('?')[0]; // removes query params
    const isDocAI = item.routerLink === '/doc-manager';
    if (
      isDocAI &&
      (currentRoute.startsWith('/doc-manager') || currentRoute.startsWith('/dashboard'))
    ) {
      return true;
    }
    return currentRoute === item.routerLink;
  }

  LoginComponent_GetConfigFile() {
    this.oDataService.DataService_GetConfigFIle().subscribe({
      next: (res) => {
        if (res.failed) {
          console.log("failed");
          // this.LoginComponent_DisplayAlertMessage(res.message, "failed", "danger");
        } else {
          let appConfigHaveMenus: boolean = this.LoginComponent_IsAppConfigHaveMenus(res);
          if (!appConfigHaveMenus) {
            res.menus = this.StaticMenus;
          }
          this.cSessionsService.SessionService_SetApplicationSideBarConfigurationFile(res);
          const oUserDetails = this.cSessionsService.SessionService_GetUserDetails();
          this.LoginComponent_HandleSideBarItems(res, oUserDetails);
        }
      },
      error: (err) => {
        console.error("Error fetching config file:", err);
      },
    });
  }
  
  LoginComponent_IsAppConfigHaveMenus(oIncomingObject)
  {
    return !!oIncomingObject.menus;
  }
  LoginComponent_HandleSideBarItems(res,oUserDetails)
  {
    if (res.env === "saas") {
        if (oUserDetails.role == 'admin' && oUserDetails.tenantId !== '1') {
            res.menus = [
              {
                 "routerLink": "/doc-manager",
                  "label": "Trillo Doc AI"
              },
              {
                 "routerLink": "/team-members",
                  "label": "Team Members"
              }
            ]
        } 
    }
    if (oUserDetails.role !== "admin" && res.env == 'non_saas') {
      const itemsToRemove = ["Admin", "Team Members", "Tasks History"];
      if (res.env !== 'non_saas') {
        itemsToRemove.push("Metadata Files");
      }
      if (oUserDetails.role == "userSFTP" && res.menus[0].label === "Trillo File Manager" ) {
        res.menus =[
          {
              "routerLink": "/filemanager",
              "label": "Trillo File Manager"
          },
          {
              "routerLink": "/settings",
              "label": "Settings"
          },
      ]
      }
      for (const itemLabel of itemsToRemove) {
        const index = res.menus.findIndex(item => item.label === itemLabel);
        if (index !== -1) {
          res.menus.splice(index, 1);
        }
      }
      
      
    }
     // Remove consecutive separators
  for (let i = 0; i < res.menus.length - 1; i++) {
    if (res.menus[i].label === "Separator" && res.menus[i + 1].label === "Separator") {
      res.menus.splice(i, 1);
      i--; 
    }
  }  
  this.drawSidebar(res);
  }


}
